// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AtsBoosterRouteImport } from './routes/ats-booster'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CreditsRouteImport } from './routes/credits'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as JobTrackerRouteImport } from './routes/job-tracker'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResumeTailorRouteImport } from './routes/resume-tailor'
import { Route as SuccessRouteImport } from './routes/success'
import { Route as TailorRouteImport } from './routes/tailor'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrackerRouteImport } from './routes/tracker'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminContactRouteImport } from './routes/admin/contact'
import { Route as AdminCreditsRouteImport } from './routes/admin/credits'
import { Route as AdminIngestionRouteImport } from './routes/admin/ingestion'
import { Route as AdminJobsRouteImport } from './routes/admin/jobs'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminStagingRouteImport } from './routes/admin/staging'
import { Route as AdminToolsRouteImport } from './routes/admin/tools'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as JobsSlugRouteImport } from './routes/jobs/$slug'
import { Route as JobsTechHiringTrendsRouteImport } from './routes/jobs/tech-hiring-trends'
import { Route as ResumeIndexRouteImport } from './routes/resume/index'
import { Route as ResumeRoleRouteImport } from './routes/resume/$role'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ApiDocsRoute = ApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => rootRouteImport
          })
const ApiKeysRoute = ApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => rootRouteImport
          })
const AtsBoosterRoute = AtsBoosterRouteImport.update({
            id: '/ats-booster',path: '/ats-booster',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CreditsRoute = CreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const JobTrackerRoute = JobTrackerRouteImport.update({
            id: '/job-tracker',path: '/job-tracker',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResumeTailorRoute = ResumeTailorRouteImport.update({
            id: '/resume-tailor',path: '/resume-tailor',getParentRoute: () => rootRouteImport
          })
const SuccessRoute = SuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => rootRouteImport
          })
const TailorRoute = TailorRouteImport.update({
            id: '/tailor',path: '/tailor',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrackerRoute = TrackerRouteImport.update({
            id: '/tracker',path: '/tracker',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminContactRoute = AdminContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => AdminRoute
          })
const AdminCreditsRoute = AdminCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AdminRoute
          })
const AdminIngestionRoute = AdminIngestionRouteImport.update({
            id: '/ingestion',path: '/ingestion',getParentRoute: () => AdminRoute
          })
const AdminJobsRoute = AdminJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminStagingRoute = AdminStagingRouteImport.update({
            id: '/staging',path: '/staging',getParentRoute: () => AdminRoute
          })
const AdminToolsRoute = AdminToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const JobsIndexRoute = JobsIndexRouteImport.update({
            id: '/jobs/',path: '/jobs/',getParentRoute: () => rootRouteImport
          })
const JobsSlugRoute = JobsSlugRouteImport.update({
            id: '/jobs/$slug',path: '/jobs/$slug',getParentRoute: () => rootRouteImport
          })
const JobsTechHiringTrendsRoute = JobsTechHiringTrendsRouteImport.update({
            id: '/jobs/tech-hiring-trends',path: '/jobs/tech-hiring-trends',getParentRoute: () => rootRouteImport
          })
const ResumeIndexRoute = ResumeIndexRouteImport.update({
            id: '/resume/',path: '/resume/',getParentRoute: () => rootRouteImport
          })
const ResumeRoleRoute = ResumeRoleRouteImport.update({
            id: '/resume/$role',path: '/resume/$role',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminContactRoute: AdminContactRoute,AdminCreditsRoute: AdminCreditsRoute,AdminIngestionRoute: AdminIngestionRoute,AdminJobsRoute: AdminJobsRoute,AdminReportsRoute: AdminReportsRoute,AdminStagingRoute: AdminStagingRoute,AdminToolsRoute: AdminToolsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,AdminRoute: AdminRouteWithChildren,ApiDocsRoute: ApiDocsRoute,ApiKeysRoute: ApiKeysRoute,AtsBoosterRoute: AtsBoosterRoute,ContactRoute: ContactRoute,CreditsRoute: CreditsRoute,FaqRoute: FaqRoute,JobTrackerRoute: JobTrackerRoute,PrivacyRoute: PrivacyRoute,ResumeTailorRoute: ResumeTailorRoute,SuccessRoute: SuccessRoute,TailorRoute: TailorRoute,TermsRoute: TermsRoute,TrackerRoute: TrackerRoute,JobsSlugRoute: JobsSlugRoute,JobsTechHiringTrendsRoute: JobsTechHiringTrendsRoute,ResumeRoleRoute: ResumeRoleRoute,JobsIndexRoute: JobsIndexRoute,ResumeIndexRoute: ResumeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)